const css = `.custom-paginator {
  margin-top: 16px;
  padding: 16px;
  border-top: 1px solid var(--surface-200);
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.custom-paginator .paginator-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: center;
  text-align: center;
}
.custom-paginator .paginator-info .paginator-text {
  font-size: var(--font-size-xs);
  color: var(--text-muted);
  display: block;
}
.custom-paginator .paginator-info .paginator-text strong {
  color: var(--text);
  font-weight: var(--font-weight-semibold);
}
.custom-paginator .paginator-info .paginator-text-mobile {
  display: none;
  font-size: var(--font-size-xs);
  color: var(--text-muted);
}
.custom-paginator .paginator-info .paginator-text-mobile strong {
  color: var(--text);
  font-weight: var(--font-weight-semibold);
}
.custom-paginator .paginator-info .paginator-range {
  font-size: var(--font-size-xs);
  color: var(--text-muted);
}
.custom-paginator .paginator-info .paginator-range strong {
  color: var(--text);
  font-weight: var(--font-weight-semibold);
}
.custom-paginator .paginator-controls {
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
}
.custom-paginator .paginator-controls .paginator-navigation {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: wrap;
  justify-content: center;
}
.custom-paginator .paginator-controls .paginator-navigation .paginator-button {
  width: 36px;
  height: 36px;
  min-width: 36px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text);
}
.custom-paginator .paginator-controls .paginator-navigation .paginator-button:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.custom-paginator .paginator-controls .paginator-navigation .paginator-button:not(:disabled):hover {
  background-color: var(--surface-100);
}
.custom-paginator .paginator-controls .paginator-navigation .paginator-pages {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: wrap;
  justify-content: center;
}
.custom-paginator .paginator-controls .paginator-navigation .paginator-pages .paginator-page {
  min-width: 36px;
  height: 36px;
  padding: 0 8px;
  border: 1px solid var(--surface-300);
  border-radius: 6px;
  background-color: var(--surface-0);
  color: var(--text);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}
.custom-paginator .paginator-controls .paginator-navigation .paginator-pages .paginator-page:hover {
  background-color: var(--surface-100);
  border-color: var(--border);
}
.custom-paginator .paginator-controls .paginator-navigation .paginator-pages .paginator-page.active {
  background-color: var(--text);
  color: var(--surface-raised);
  border-color: var(--text);
}
.custom-paginator .paginator-controls .paginator-navigation .paginator-pages .paginator-page.active:hover {
  background-color: var(--text-muted);
}
.custom-paginator .paginator-controls .paginator-navigation .paginator-pages .paginator-ellipsis {
  padding: 0 4px;
  color: var(--text-muted);
  font-size: var(--font-size-sm);
  user-select: none;
}
.custom-paginator .paginator-controls .paginator-page-size {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: var(--font-size-xs);
  color: var(--text-muted);
}
.custom-paginator .paginator-controls .paginator-page-size .page-size-label {
  white-space: nowrap;
}
.custom-paginator .paginator-controls .paginator-page-size .page-size-select {
  padding: 8px 12px;
  border: 1px solid var(--surface-300);
  border-radius: 6px;
  background-color: var(--surface-0);
  color: var(--text);
  font-size: var(--font-size-sm);
  cursor: pointer;
  transition: border-color 0.2s ease;
}
.custom-paginator .paginator-controls .paginator-page-size .page-size-select:hover {
  border-color: var(--border);
}
.custom-paginator .paginator-controls .paginator-page-size .page-size-select:focus {
  outline: none;
  border-color: var(--text);
}
@media (max-width: 768px) {
  .custom-paginator {
    padding: 12px;
  }
  .custom-paginator .paginator-info .paginator-text {
    display: none;
  }
  .custom-paginator .paginator-info .paginator-text-mobile {
    display: block;
  }
  .custom-paginator .paginator-info .paginator-range {
    font-size: var(--font-size-xs);
  }
  .custom-paginator .paginator-controls .paginator-navigation .paginator-button {
    width: 40px;
    height: 40px;
    min-width: 40px;
  }
  .custom-paginator .paginator-controls .paginator-navigation .paginator-pages .paginator-page {
    min-width: 40px;
    height: 40px;
    font-size: var(--font-size-sm);
  }
  .custom-paginator .paginator-controls .paginator-page-size {
    font-size: var(--font-size-xs);
    flex-direction: column;
    gap: 4px;
    width: 100%;
  }
  .custom-paginator .paginator-controls .paginator-page-size .page-size-select {
    width: 100%;
    max-width: 150px;
    padding: 8px 12px;
  }
}
@media (max-width: 480px) {
  .custom-paginator {
    padding: 12px 8px;
    gap: 12px;
  }
  .custom-paginator .paginator-info .paginator-range {
    font-size: var(--font-size-2xs);
  }
  .custom-paginator .paginator-controls {
    gap: 12px;
  }
  .custom-paginator .paginator-controls .paginator-navigation {
    gap: 2px;
  }
  .custom-paginator .paginator-controls .paginator-navigation .paginator-button {
    width: 36px;
    height: 36px;
    min-width: 36px;
  }
  .custom-paginator .paginator-controls .paginator-navigation .paginator-pages {
    gap: 2px;
  }
  .custom-paginator .paginator-controls .paginator-navigation .paginator-pages .paginator-page {
    min-width: 32px;
    height: 32px;
    padding: 0 4px;
    font-size: var(--font-size-sm);
  }
  .custom-paginator .paginator-controls .paginator-page-size {
    font-size: var(--font-size-2xs);
  }
  .custom-paginator .paginator-controls .paginator-page-size .page-size-label {
    display: none;
  }
  .custom-paginator .paginator-controls .paginator-page-size .page-size-select {
    font-size: var(--font-size-sm);
    padding: 8px 12px;
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
